import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  homeBreadCrumb: {
    id: 'courseHome.coordinatorTrackingTab.breadcrumb.home',
    defaultMessage: 'Home',
    description: 'Home breadcrumb shown on coordinator tracking tab page',
  },
  trackingBreadCrumb: {
    id: 'courseHome.coordinatorTrackingTab.breadcrumb.tracking',
    defaultMessage: 'Coordinator Tracking',
    description: 'Coordinator tracking breadcrumb shown on coordinator tracking tab page',
  },
  coordinatorTrackingHeading: {
    id: 'courseHome.coordinatorTrackingTab.heading.coordinatorTracking',
    defaultMessage: 'Coordinator Tracking',
    description: 'Coordinator tracking main heading',
  },
  coordinatorTrackingOverview: {
    id: 'courseHome.coordinatorTrackingTab.heading.coordinatorTracking.overview',
    defaultMessage: 'Overview',
    description: 'Coordinator tracking overview heading',
  },
  noRecord: {
    id: 'courseHome.coordinatorTrackingTab.noRecords',
    defaultMessage: 'No record found',
    description: 'Coordinator tracking no records found',
  },
  commentsHeading: {
    id: 'courseHome.coordinatorTrackingTab.heading.comments',
    defaultMessage: 'Comments',
    description: 'Coordinator tracking comments heading',
  },
});

export default messages;
